type Props = {
  className?: string
  filled: boolean
}

const ThumbIcon = ({className, filled}: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='19'
      fill='none'
      viewBox='0 0 21 19'
      className={className}
    >
      {!filled ? (
        <path
          fill='#999'
          d='M2.472 12.167q-.714 0-1.26-.548-.548-.547-.548-1.26V8.744q0-.158.04-.338t.09-.336l2.867-6.762q.215-.48.72-.81A1.9 1.9 0 0 1 5.437.166h10.516v12l-5.818 5.767a1.2 1.2 0 0 1-.69.355 1.2 1.2 0 0 1-.752-.134 1.18 1.18 0 0 1-.527-.546 1.06 1.06 0 0 1-.071-.733l1.077-4.71zm11.98-.639V1.667H5.434q-.105 0-.216.057a.37.37 0 0 0-.168.193l-2.885 6.75v1.692a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.086h8.597l-1.254 5.481zM18.857.167q.746 0 1.277.53.531.532.531 1.277v8.385q0 .745-.53 1.277a1.74 1.74 0 0 1-1.278.53h-2.903v-1.5h2.903a.3.3 0 0 0 .222-.086.3.3 0 0 0 .086-.221V1.974a.3.3 0 0 0-.086-.221.3.3 0 0 0-.222-.086h-2.903v-1.5z'
        />
      ) : (
        <path
          fill='#3957EA'
          d='M19.028 6.833q.714 0 1.26.548.549.547.548 1.26v1.616a1.9 1.9 0 0 1-.13.673L17.84 17.69q-.216.48-.721.812-.506.33-1.052.33H7.97q-.747 0-1.277-.53a1.74 1.74 0 0 1-.53-1.277V7.58q0-.36.148-.695.148-.333.394-.58l5.29-5.255q.3-.284.69-.348a1.2 1.2 0 0 1 .753.117q.36.183.519.536t.063.752l-1.077 4.725zm-16.384 12q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.277V8.64q0-.747.53-1.278.53-.53 1.278-.53h.211q.749 0 1.278.53.53.531.53 1.278v8.394q0 .75-.53 1.273a1.75 1.75 0 0 1-1.278.526z'
        />
      )}
    </svg>
  )
}

export default ThumbIcon
